import { useEffect } from "react";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Spinner from "../../../../assets/icons/Spinner";
import Message from "../../../../i18n/Message";
import ToolTile from "./ToolTile";
import { loadToolPlugins } from "../store/toolPluginActionCreators";
import { toolPluginSelectors } from "../store/toolPluginReducer";

import "./ToolPluginListPage.scss";
import NewWorkspaceLayout from "../../layout/NewWorkspaceLayout";
import LogoMCP from "../../../../assets/icons/LogoMCP";
import AddMCPServerDialog from "./AddMCPServerDialog";
import McpServerTile from "./McpServerTile";

const ToolPluginListPage = () => {
  const [showCreate, setShowCreate] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { workspaceId } = useParams();
  const toolPluginList = useSelector(toolPluginSelectors.getList);
  const listCounter = useSelector(toolPluginSelectors.getListCounter);

  useEffect(() => {
    if (workspaceId) {
      dispatch(loadToolPlugins(intl, workspaceId));
    }
  }, [dispatch, intl, workspaceId, listCounter]);

  return (
    <NewWorkspaceLayout contentPanelClassName="tool_plugin_list_page">
      <div className="breadcrumbs">&nbsp;</div>
      <h1>
        <Message id="menu_tool_plugins" />
      </h1>
      <div className="actions_panel">
        <button
          className="btn btn-outline-dark"
          onClick={() => setShowCreate(true)}
        >
          <LogoMCP size={18} color="#000" />
          <Message id="tools_add_mcp_server_btn" />
        </button>
      </div>
      <div className="body_content">
        <div className="content_header">
          <div></div>
        </div>
        <div className="tool_plugin_tiles">
          {!toolPluginList && <Spinner />}
          {toolPluginList &&
            toolPluginList.map((tool) => (
              <McpServerTile key={tool.uid} toolPlugin={tool} />
            ))}
        </div>
      </div>
      {showCreate && (
        <AddMCPServerDialog onClose={() => setShowCreate(false)} />
      )}
    </NewWorkspaceLayout>
  );
};

export default ToolPluginListPage;
